import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'
import { media } from '../../styles/utils'
import { bgIcon } from '../../styles/global';

import Check from 'svg-react-loader?name=Icon!../../assets/icons/check-white.svg';

class Checkbox extends Component {

    state = {
        selected: this.props.value
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.value !== this.state.selected) {
            this.setState({ selected: nextProps.value })
        }
    }

    handleClick = val => {
        this.setState({ selected: val });
        this.props.onChangeValue(val);
    }

    render() {
        const { selected } = this.state;
        return (
            <Wrapper>
 
                <Indicator
                    onClick={() => this.handleClick(!selected)}
                    active={this.state.selected}
                >
                    <Check/>
                </Indicator>

                <Label>{this.props.label}</Label>

            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    position: relative;
    display: flex;

    ${media.tablet`

    `}

    ${media.phone`

    `}
`

const Label = styled.div`
    display: flex;
    width: 100%;
    font-family: 'Platform-Regular';
    font-size: 11px;
    color: #807c7c;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 4px;
`


const Indicator = styled.div`
    width: 17px;
    height: 17px;   
    flex: 1 0 17px;
    max-width: 17px;
    border: 1px solid #C3C3C3;
    margin-right: 42px;
    transform: translateY(4px);
    border-radius: 50%;
    position: relative; 
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;
    
    transition: all 0.10s ease;

    > * { 
        opacity: 0;
    }

    ${props => {
        if (props.active) return css`
            background: #7ED321;
            border: 2px solid #7ED321;
            border: 0;  

            > * { 
                opacity: 1;
            }
        `
    }}
`


export default Checkbox;



// WEBPACK FOOTER //
// ./client/components/Checkbox/Checkbox.js